export const badgeTypes = ['experiment', 'beta', null];
export const badgeTypeValidator = (value) => badgeTypes.includes(value);
